
/**
 * 애플리케이션 루트 컴포넌트
 */

import React from 'react';
import { Global } from '@emotion/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { globalStyles } from './shared/styles/globalStyles';
import AppRoutes from './routes/AppRoutes';

// React Query 클라이언트 설정
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 전역 캐시 설정
      staleTime: 1000 * 60 * 60 * 6,   // 6시간
      gcTime:   1000 * 60 * 60 * 12,  // 12시간
      refetchOnWindowFocus: false, // 윈도우 포커스 시 리페칭 비활성화
      retry: 1, // 실패 시 1번만 재시도
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Global styles={globalStyles} />
      <AppRoutes />
      {/* 개발 환경에서만 React Query Devtools 표시 */}
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

export default App;
